module.exports = __webpack_public_path__ + "static/media/details_fond.f8da4af3.jpg";